import { FontItem } from '../types/font-types';
import { getFontFullPath } from '../utils/fontPathUtils';

export const FONT_DEFAULT_VALUE = {
  name: 'Inter',
  url: getFontFullPath('Inter-Medium.ttf'),
  scale: 122
};
export const FONTS_DEFAULT: FontItem[] = [
  FONT_DEFAULT_VALUE,
  {
    name: 'Playfair Display',
    url: getFontFullPath('PlayfairDisplay-Bold.ttf'),
    scaleInPx: 3,
    scale: 143
  },
  {
    name: 'Montagu Slab',
    url: getFontFullPath('MontaguSlab_24pt-Bold.ttf'),
    scaleInPx: 4,
    scale: 146
  },
  {
    name: 'Bangers',
    url: getFontFullPath('Bangers-Regular.ttf'),
    scaleInPx: 13,
    isOverlayFont: true,
    scale: 178
  },
  {
    name: 'Space Mono',
    url: getFontFullPath('SpaceMono-Bold.ttf'),
    scale: 151,
    isOverlayFont: true
  },
  {
    name: 'Source Code Pro',
    url: getFontFullPath('SourceCodePro-Bold.ttf'),
    scale: 155,
    isOverlayFont: true
  },
  {
    name: 'Rubik',
    url: getFontFullPath('Rubik-Bold.ttf'),
    scale: 156,
    isOverlayFont: true
  },
  {
    name: 'Roboto',
    url: getFontFullPath('Roboto-Medium.ttf'),
    scale: 122,
    isOverlayFont: true
  },
  {
    name: 'Raleway',
    url: getFontFullPath('Raleway-Bold.ttf'),
    scale: 141,
    isOverlayFont: true
  },
  {
    name: 'Poppins',
    url: getFontFullPath('Poppins-Bold.ttf'),
    scale: 180,
    isOverlayFont: true
  },
  {
    name: 'Merriweather',
    url: getFontFullPath('Merriweather-Bold.ttf'),
    scaleInPx: 3,
    scale: 136,
    isOverlayFont: true
  },
  {
    name: 'Nunito',
    url: getFontFullPath('Nunito-Bold.ttf'),
    scaleInPx: 3,
    scale: 139,
    isOverlayFont: true
  },
  {
    name: 'Montserrat',
    url: getFontFullPath('Montserrat-ExtraBold.ttf'),
    scaleInPx: 4,
    scale: 139,
    isOverlayFont: true
  },
  {
    name: 'Alegreya',
    url: getFontFullPath('Alegreya-Bold.ttf'),
    scaleInPx: 6,
    scale: 149,
    isOverlayFont: true
  },
  {
    name: 'Lato',
    url: getFontFullPath('Lato-Bold.ttf'),
    scale: 121,
    isOverlayFont: true
  },
  {
    name: 'Open Sans',
    url: getFontFullPath('OpenSans-Bold.ttf'),
    scaleInPx: 4,
    scale: 146,
    isOverlayFont: true
  },
  {
    name: 'Pacifico',
    url: getFontFullPath('Pacifico-Regular.ttf'),
    scale: 199,
    scaleInPx: 15
  },
  {
    name: 'Patrick Hand',
    url: getFontFullPath('PatrickHand-Regular.ttf'),
    scale: 138,
    scaleInPx: 3
  },
  {
    name: 'Manrope',
    url: getFontFullPath('Manrope-ExtraBold.ttf'),
    scale: 138,
    scaleInPx: 3
  },
  {
    name: 'Oswald',
    url: getFontFullPath('Oswald-Bold.ttf'),
    scale: 173,
    scaleInPx: 9
  },
  {
    name: 'Roboto Mono',
    url: getFontFullPath('RobotoMono-Bold.ttf'),
    scale: 135,
    scaleInPx: 1
  },
  {
    name: 'Monoton',
    url: getFontFullPath('Monoton-Regular.ttf'),
    scale: 159,
    scaleInPx: 7
  },
  {
    name: 'League Script',
    url: getFontFullPath('LeagueScript-Regular.ttf'),
    size: 'xs',
    scale: 113,
    scaleInPx: -1
  },
  {
    name: 'KOMIKAX',
    url: getFontFullPath('KOMIKAX.ttf'),
    isOverlayFont: true
  },
  {
    name: 'Albert Sans',
    url: getFontFullPath('AlbertSans.ttf'),
    isOverlayFont: true
  },
  {
    name: 'Coda',
    url: getFontFullPath('Coda-ExtraBold.ttf'),
    isOverlayFont: true
  },
  {
    name: 'Luckiest Guy',
    url: getFontFullPath('LuckiestGuy-Regular.ttf'),
    isOverlayFont: true
  },
  {
    name: 'Titan One',
    url: getFontFullPath('TitanOne-Regular.ttf'),
    isOverlayFont: true
  },
  {
    name: 'Anton',
    url: getFontFullPath('Anton-Regular.ttf'),
    isOverlayFont: true
  },
  {
    name: 'Alex Brush',
    url: getFontFullPath('AlexBrush-Regular.ttf'),
    isOverlayFont: true
  }
]; /**
 * Preset "web safe" options from admin TypographySection (`value` = API `web_safe_font.originalName`).
 * Upload each `file` to the `content-lab/fonts/` S3 prefix (see getFontFullPath). Custom font weights use `weight_*` URLs from uploads.
 */

export const PLATFORM_BRAND_KIT_PRESET_FONTS: ReadonlyArray<{
  originalName: string;
  name: string;
  file: string;
}> = [
  { originalName: 'Inter', name: 'Inter', file: 'Inter-Medium.ttf' },
  { originalName: 'Default-GT-America', name: 'GT America', file: 'Default-GT-America-Medium.ttf' },
  { originalName: 'Times New Roman', name: 'Times New Roman', file: 'TimesNewRoman-Medium.ttf' },
  { originalName: 'Arial', name: 'Arial', file: 'Arial-Medium.ttf' },
  { originalName: 'Verdana', name: 'Verdana', file: 'Verdana-Medium.ttf' },
  { originalName: 'Tahoma', name: 'Tahoma', file: 'Tahoma-Medium.ttf' },
  { originalName: 'Georgia', name: 'Georgia', file: 'Georgia-Medium.ttf' },
  { originalName: 'Garamond', name: 'Garamond', file: 'Garamond-Medium.ttf' },
  { originalName: 'Helvetica', name: 'Helvetica', file: 'Helvetica-Medium.ttf' },
  { originalName: 'Courier New', name: 'Courier New', file: 'CourierNew-Medium.ttf' }
];
export const FONT_STYLESHEET_EXACT_HOSTNAMES = new Set([
  'fonts.googleapis.com',
  'fonts.gstatic.com',
  'use.typekit.net',
  'fonts.bunny.net',
  'api.fonts.coollabs.io'
]);
export const FONT_STYLESHEET_HOSTNAME_SUFFIXES = ['.typekit.net'];
export const WEIGHT_SLOT_KEY_RE = /^weight_(100|200|300|400|500|600|700|800|900)$/;
export const DEFAULT_FONT_REGULAR = 'Inter-Regular.ttf';
export const DEFAULT_FONT_MEDIUM = 'Inter-Medium.ttf';
